import { JOB_CATEGORIES_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const JobCategoriesService = {
  getAll: (params?: any) => requests.get(`${JOB_CATEGORIES_URL}`, params),
  create: (params: any) => requests.post(`${JOB_CATEGORIES_URL}`, params),
  getSingle: (id: number) => requests.get(`${JOB_CATEGORIES_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.put(`${JOB_CATEGORIES_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${JOB_CATEGORIES_URL}/${id}`),
  getRecommendedCategories: () =>
    requests.get(`${JOB_CATEGORIES_URL}/recommended-categories`),
  approveRecommendedCategory: (params: any) =>
    requests.post(`${JOB_CATEGORIES_URL}/recommended-categories`, params),
  declineRecommendedCategory: (params: { name: string; category: number }) =>
    requests.post(
      `${JOB_CATEGORIES_URL}/recommended-categories/reject-suggestion`,
      params
    ),
  deleteRecommendedSuggestion: (params: { name: string }) =>
    requests.post(
      `${JOB_CATEGORIES_URL}/recommended-categories/delete-suggestion`,
      params
    ),
};
